// import Loading from "components/common/Loading";

// const rangeToneClass = (distKm) => {
//   if (!Number.isFinite(distKm))  return "bg-gray-100 text-gray-700";
//   if (distKm <= 0.5)             return "bg-emerald-100 text-emerald-700";
//   if (distKm <= 1.5)             return "bg-blue-100 text-blue-700";
//   if (distKm <= 5)               return "bg-amber-100 text-amber-700";
//   return "bg-rose-100 text-rose-700";
// };

// export default function AttendanceTable({
//   loading,
//   pageRows,
//   sortedDescLength,
//   page,
//   totalPages,
//   start,
//   end,
//   onPagePrev,
//   onPageNext,
//   onEmployeeClick,
// }) {
//   return (
//     <div className="rounded-2xl border border-gray-200 bg-white p-4 dark:border-white/10 dark:bg-navy-800">
//       <div className="overflow-x-auto">
//         <table className="min-w-full text-left text-sm">
//           <thead className="bg-gray-50 text-gray-600 dark:bg-white/5 dark:text-white/70">
//             <tr>
//               {["Employee", "Date", "Check In", "Check Out", "Hours", "Break", "Status", "Range"].map(
//                 (h) => <th key={h} className="px-4 py-3">{h}</th>
//               )}
//             </tr>
//           </thead>

//           <tbody>
//             {loading ? (
//               <tr><td colSpan="8"><Loading variant="dots" fullscreen /></td></tr>
//             ) : pageRows.length === 0 ? (
//               <tr>
//                 <td colSpan="8" className="px-4 py-6 text-center text-gray-500 dark:text-white">
//                   No records.
//                 </td>
//               </tr>
//             ) : (
//               pageRows.map((r) => (
//                 <tr key={r._id} className="border-t border-gray-100 dark:border-white/10">
//                   <td className="px-4 py-3 font-medium text-navy-700 dark:text-white">
//                     <button
//                       onClick={() => onEmployeeClick(r.employeeId)}
//                       className="font-semibold text-red-500 underline hover:text-orange-500"
//                     >
//                       {r._displayName}
//                     </button>
//                   </td>

//                   <td className="px-4 py-3 dark:text-white">{r.workDay || "-"}</td>
//                   <td className="px-4 py-3 dark:text-white">{r.in || "-"}</td>
//                   <td className="px-4 py-3 dark:text-white">{r.out || "-"}</td>
//                   <td className="px-4 py-3 dark:text-white">{r.hours}</td>
//                   <td className="px-4 py-3 dark:text-white">{r._breakMin ? `${r._breakMin} Min` : "-"}</td>

//                   <td className="px-4 py-3">
//                     <span className={`rounded-full px-2 py-1 text-xs font-medium ${
//                       r.status === "Present"
//                         ? "bg-green-100 text-green-700"
//                         : "bg-red-100 text-red-700"
//                     }`}>
//                       {r.status}
//                     </span>
//                   </td>

//                   <td className="px-4 py-3">
//                     <span
//                       className={`rounded-full px-2 py-1 text-xs font-semibold ${rangeToneClass(r._distKm)} dark:text-white`}
//                       title={Number.isFinite(r._distKm) ? `${r._distKm.toFixed(2)} km` : undefined}
//                     >
//                       {r._distLabel}
//                     </span>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       <div className="mt-4 flex items-center justify-between text-sm text-gray-600">
//         <div>
//           Showing{" "}
//           <span className="font-medium">{sortedDescLength ? start + 1 : 0}</span>
//           {" "}to{" "}
//           <span className="font-medium">{Math.min(end, sortedDescLength)}</span>
//           {" "}of{" "}
//           <span className="font-medium">{sortedDescLength}</span> entries
//         </div>

//         <div className="flex items-center gap-2">
//           <button
//             className="rounded-lg border px-3 py-1 disabled:opacity-50"
//             disabled={page === 1}
//             onClick={onPagePrev}
//           >
//             Prev
//           </button>
//           <span>Page {page} / {totalPages}</span>
//           <button
//             className="rounded-lg border px-3 py-1 disabled:opacity-50"
//             disabled={page === totalPages}
//             onClick={onPageNext}
//           >
//             Next
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// src/views/hrms/attendance/components/AttendanceTable.jsx
import Loading from "components/common/Loading";
import { statusBadgeClass, rangeToneClass, STATUS_CONFIG } from "../utils/attendanceUtils";

export default function AttendanceTable({
  loading,
  pageRows,
  sortedDescLength,
  page,
  totalPages,
  start,
  end,
  onPagePrev,
  onPageNext,
  onEmployeeClick,
}) {
  return (
    <div>
      <div className="overflow-x-auto">
        <table className="min-w-full text-left text-sm">
          <thead className="bg-gray-50 text-gray-600 dark:bg-white/5 dark:text-white/70">
            <tr>
              {[
                "Employee", "Date", "Check In", "Check Out",
                "Hours", "Break", "Status", "Late By", "Range",
              ].map((h) => (
                <th key={h} className="px-4 py-3 whitespace-nowrap">{h}</th>
              ))}
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan="9">
                  <Loading variant="dots" fullscreen />
                </td>
              </tr>
            ) : pageRows.length === 0 ? (
              <tr>
                <td
                  colSpan="9"
                  className="px-4 py-6 text-center text-gray-500 dark:text-white"
                >
                  No records found.
                </td>
              </tr>
            ) : (
              pageRows.map((r) => (
                <tr
                  key={r._id}
                  className="border-t border-gray-100 dark:border-white/10"
                >
                  {/* Employee name */}
                  <td className="px-4 py-3">
                    <button
                      onClick={() => onEmployeeClick(r.employeeId)}
                      className="font-semibold text-red-500 underline hover:text-orange-500"
                    >
                      {r._displayName}
                    </button>
                  </td>

                  {/* Date */}
                  <td className="px-4 py-3 dark:text-white whitespace-nowrap">
                    {r.workDay || "-"}
                  </td>

                  {/* Check in */}
                  <td className="px-4 py-3 dark:text-white">
                    {r._weeklyOff || r._holiday ? "-" : r.in || "-"}
                  </td>

                  {/* Check out */}
                  <td className="px-4 py-3 dark:text-white">
                    {r._weeklyOff || r._holiday ? "-" : r.out || "-"}
                  </td>

                  {/* Hours */}
                  <td className="px-4 py-3 dark:text-white">
                    {r._weeklyOff || r._holiday ? "-" : r.hours}
                  </td>

                  {/* Break */}
                  <td className="px-4 py-3 dark:text-white">
                    {r._breakMin && !r._weeklyOff && !r._holiday
                      ? `${r._breakMin} min`
                      : "-"}
                  </td>

                  {/* Status badge */}
                  <td className="px-4 py-3">
                    <span
                      className={`rounded-full px-2 py-1 text-xs font-medium ${statusBadgeClass(r.status)}`}
                    >
                      {STATUS_CONFIG[r.status]?.label || r.status}
                    </span>
                  </td>

                  {/* Late by */}
                  <td className="px-4 py-3 dark:text-white">
                    {r.status === "Late" && r.lateByMins
                      ? `${r.lateByMins} min`
                      : "-"}
                  </td>

                  {/* GPS range */}
                  <td className="px-4 py-3">
                    <span
                      className={`rounded-full px-2 py-1 text-xs font-semibold ${rangeToneClass(r._distKm)} dark:text-white`}
                      title={
                        Number.isFinite(r._distKm)
                          ? `${r._distKm.toFixed(2)} km`
                          : undefined
                      }
                    >
                      {r._distLabel}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="mt-4 flex items-center justify-between text-sm text-gray-600 dark:text-white/70">
        <div>
          Showing{" "}
          <span className="font-medium">{sortedDescLength ? start + 1 : 0}</span>
          {" "}–{" "}
          <span className="font-medium">{Math.min(end, sortedDescLength)}</span>
          {" "}of{" "}
          <span className="font-medium">{sortedDescLength}</span> entries
        </div>

        <div className="flex items-center gap-2">
          <button
            className="rounded-lg border px-3 py-1 disabled:opacity-50 dark:border-white/10 dark:text-white"
            disabled={page === 1}
            onClick={onPagePrev}
          >
            Prev
          </button>
          <span className="dark:text-white">
            Page {page} / {totalPages}
          </span>
          <button
            className="rounded-lg border px-3 py-1 disabled:opacity-50 dark:border-white/10 dark:text-white"
            disabled={page === totalPages}
            onClick={onPageNext}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
}